<!--
 * @Author: 范向玲
 * @Date: 2022-12-08 13:48:05
 * @LastEditors: 范向玲
 * @LastEditTime: 2023-01-03 15:48:05
 * @Description: 矿业资讯-数据新增
 * @FilePath: \src\components\DataManagement\roleManagement\roleManagement.vue
-->
<template>
  <section class="add-container">
    <section class="add-item" v-for="item in option" :key="item.dataIndex">
      <section class="add-label">{{ item.label }}：</section>
      <section class="add-component">
        <a-input v-show="item.type === 'input'" v-model:value="item[item.dataIndex]" />
        <a-date-picker
          :disabled-date="disabledDate"
          v-show="item.type === 'datePicker'"
          v-model:value="item[item.dataIndex]"
          valueFormat="YYYY-MM-DD"
          class="info-date-picker" />
      </section>
    </section>
  </section>
</template>

<script setup>
import moment from 'moment';
import { ref, reactive, computed, toRefs, watch, onMounted, onBeforeMount, defineProps, } from 'vue';

const props = defineProps({
  option: {
    type: Array,
  },
});

const disabledDate = current => {
  return current && current > moment().endOf('day');
};

</script>

<style lang="scss">
 /* 新增表单样式 */
.add-container {
  .add-item {
    display: flex;
    margin: 0.05rem 0;
    .add-label {
      width: 0.9rem;
      font-size: 0.14rem;
      line-height: 0.43rem;
      height: 0.43rem;
    }
    .add-component {
      width: calc(100% - 0.9rem);
    }
  }
  .info-date-picker {
    width: 100%;
  }
}
</style>